import {Component, EventEmitter, Input, Output} from '@angular/core';
import * as moment from 'moment';
import {Moment} from 'moment';

@Component({
  selector: 'dialog-datepicker',
  templateUrl: './dialog-datepicker.component.html',
  styleUrls: ['./dialog-datepicker.component.css'],
})
export class DialogDatepickerComponent {

  @Input() public minDate: Date;
  @Input() public isOptional: boolean;
  @Input() public isTimeOnly: boolean;
  @Output() public dateChange: EventEmitter<Date> = new EventEmitter();
  public utcDate: Date;

  public get valid(): boolean {
    return this.utcDate ? true : false;
  }

  public get invalid(): boolean {
    return !this.valid;
  }

  // HACK:
  // We need to display UTC time but Datepicker and Timepicker are using
  // local time. So as a workaround we add/subtract the timezone offset.
  // If it's dumb, but it works, it ain't dumb.
  public updateUtcDate(originalDate: Date): void {
    if (!originalDate) {
      return;
    }

    const date: Moment = moment(originalDate);
    date.add(-date.utcOffset(), 'minutes');

    this.utcDate = date.toDate();
  }

  public handleDateChange(date: Date, type: number): void { // tslint:disable-line
    if ( type == 1 && this.utcDate) {
      date.setHours(this.utcDate.getHours());
      date.setMinutes(this.utcDate.getMinutes());
    }
    this.utcDate = date;

    const newDate: Moment = moment(date);
    newDate.add(newDate.utcOffset(), 'minutes');

    this.dateChange.emit(newDate.toDate());
  }

  public get startDate(): string {
    if (!this.utcDate) {
      return '';
    }

    const date: Moment = moment(this.utcDate);
    return date.format('DD.MM.YYYY');
  }

  private resetDate(): void { // tslint:disable-line
    this.utcDate = undefined;
    this.dateChange.emit(null);
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/dialogs/dialogs-details/dialog-datepicker/dialog-datepicker.component.ts